import { IFAQ } from '@upkey-platform/core/core-shared'
export const JOB_MATCH_WIDGET_DATA = {
  title: 'Job match',
  content: `<p>Is your resume compatible with your dream job? Let’s check!</p>`,
  imageURL: 'assets/images/pages/public/shared/career-widget.svg',
  imageALT: 'job-illustration'
}
export const RESUME_BUILDER_WIDGET_DATA = {
  title: 'Resume Builder',
  content: `<p>Design a stunning resume. Make sure you stand out and land your dream job!</p>`,
  imageURL: 'assets/images/pages/public/shared/resume-widget.svg',
  imageALT: 'resume'
}

export const RESUME_SCORE_WIDGET_DATA = {
  title: 'Resume Score',
  content: `<p>Want to know how strong your resume is? Upload your resume, find out your score, and get suggestions on how to improve!</p>`,
  imageURL: 'assets/images/pages/public/shared/resume-score-widget.svg',
  responsiveImageURL: 'assets/images/pages/public/shared/resume-score-responsive.svg',
  imageALT: 'resume-score'
}

export const HOME_TESTIMONIALS = [
  {
    id: 'profile2',
    imageWidth: '380',
    imageHeight: '600',
    type: 'video',
    profileImg: 'assets/images/pages/public/home/testimonials_pics/thumbnails/abbeyherod.png',
    profileName: '@abbeyherod',
    videoOrigin: 'tiktok',
    videoId: 'https://upkey-platform.s3.amazonaws.com/assets/videos/cat.mp4'
  },

  {
    profileImg: 'assets/images/pages/public/home/testimonials_pics/taylor-johnson.jpg',
    profileImgWebP: 'assets/images/pages/public/home/testimonials_pics/taylor-johnson-copy.webp',
    comment: `I know for certain that every minute I've spent with
    Upkey's tools and programs has made me a better candidate and a better person.`,
    profileName: 'Taylor Johnson',
    id: 'profile3',
    specialization: `Communication and Media Studies, University of Iowa`,
    imageWidth: '335',
    imageHeight: '221',
    type: 'text'
  },
  {
    id: 'profile4',

    imageWidth: '380',
    imageHeight: '600',
    type: 'video',
    profileImg: 'assets/images/pages/public/home/testimonials_pics/thumbnails/yoyojoe_1.png',
    profileName: '@yoyojoe_1',
    videoOrigin: 'tiktok',
    videoId: 'https://upkey-platform.s3.amazonaws.com/assets/videos/Upkey+Resume+video+final.mp4'
  },

  {
    profileImg: 'assets/images/pages/public/home/testimonials_pics/lily-ofori.jpg',
    profileImgWebP: 'assets/images/pages/public/home/testimonials_pics/lily-ofori-copy.webp',
    comment:
      'My experience with Upkey has been life-changing. They see me as a student and get what I am going through. I feel so much more confident about who I am.',
    profileName: 'Lily Ofori-Amanfo',
    id: 'profile5',
    specialization: `Bachelor's degree, Management Information Systems, Ashesi University`,
    imageWidth: '335',
    imageHeight: '221',
    type: 'text'
  },
  {
    id: 'profile6',
    imageWidth: '380',
    imageHeight: '600',
    type: 'video',
    profileImg: 'assets/images/pages/public/home/testimonials_pics/thumbnails/rojtwins.png',
    profileName: '@rojtwins',
    videoOrigin: 'tiktok',
    videoId:
      'https://upkey-platform.s3.amazonaws.com/assets/videos/Snaptik_6923663401419951365_roj-twins.mp4'
  },
  {
    profileImg: 'assets/images/pages/public/home/testimonials_pics/anibaba-ayodeji.jpg',
    profileImgWebP: 'assets/images/pages/public/home/testimonials_pics/anibaba-ayodeji-copy.webp',
    comment: `Upkey has improved my managerial skills, communication skills, and so much more. It has given me the confidence to face anything in my professional journey.`,
    profileName: 'Anibaba Ayodeji',
    id: 'profile7',
    specialization: `Bachelor of Science - BS, Mechanical Engineering, Lagos State University`,
    imageWidth: '335',
    imageHeight: '221',
    type: 'text'
  },
  {
    id: 'profile8',

    imageWidth: '380',
    imageHeight: '600',
    type: 'video',
    profileImg: 'assets/images/pages/public/home/testimonials_pics/thumbnails/yandaceo.png',
    profileName: '@yandaceo',
    videoOrigin: 'tiktok',
    videoId:
      'https://upkey-platform.s3.amazonaws.com/assets/videos/Snaptik_7104751340210965802_iyanna-business-tips.mp4'
  },
  {
    profileImg: 'assets/images/pages/public/home/testimonials_pics/lucy-cai.jpg',
    profileImgWebP: 'assets/images/pages/public/home/testimonials_pics/lucy-cai-copy.webp',
    comment:
      'Upkey truly prepares individuals for any career they set out to achieve. I connected with professionals and built my entrepreneurial skills!',
    profileName: 'Lucy Cai',
    id: 'profile9',
    specialization: `Student, Oakton High School (Herndon, Virginia)`,
    imageWidth: '335',
    imageHeight: '221',
    type: 'text'
  },

  {
    thumbnail:
      'assets/images/pages/public/self-branding-course/course-thumbnails/01-live-how-to-find-your-voice.jpg',
    id: 'profile10',
    imageWidth: '380',
    imageHeight: '600',
    type: 'video',
    profileImg: 'assets/images/pages/public/home/testimonials_pics/thumbnails/bbyrlaaa.png',
    profileName: '@bbyrlaaa',
    videoOrigin: 'tiktok',
    videoId: 'https://upkey-platform.s3.amazonaws.com/assets/videos/dark.mp4'
  },

  {
    profileImg: 'assets/images/pages/public/home/testimonials_pics/dareen-christabel.jpg',
    profileImgWebP: 'assets/images/pages/public/home/testimonials_pics/dareen-christabel-copy.webp',
    comment: `Upkey's programs have been such an eye-opening experience for me. Upkey has encouraged me to think and reflect on the world's current status and brainstorm ways to solve significant problems.`,
    profileName: 'Dareen Christabel',
    id: 'profile11',
    specialization: `Bachelor of Arts - BA, Psychology, DORDT University`,
    imageWidth: '335',
    imageHeight: '221',
    type: 'text'
  },

  {
    profileImg: 'assets/images/pages/public/home/testimonials_pics/profile5.png',
    profileImgWebP: 'assets/images/pages/public/home/testimonials_pics/profile5.webp',
    comment: 'I would not change my experience with Upkey for anything!',
    profileName: 'Vani Kurup',
    id: 'profile12',
    specialization: `High School Student, South Fayette Township High School`,
    imageWidth: '217',
    imageHeight: '183',
    type: 'text'
  },

  {
    profileImg: 'assets/images/pages/public/home/testimonials_pics/profile7.png',
    profileImgWebP: 'assets/images/pages/public/home/testimonials_pics/profile7.webp',
    comment: 'Upkey is the best thing that ever happened to me after moving to the U.S.A.',
    profileName: 'Astha Arora',
    id: 'profile13',
    specialization: `M.B.A, Finance and financial Management Services, Lambton College`,
    imageWidth: '182',
    imageHeight: '152',
    type: 'text'
  },
  {
    profileImg: 'assets/images/pages/public/home/testimonials_pics/profile6.png',
    profileImgWebP: 'assets/images/pages/public/home/testimonials_pics/profile6.webp',
    comment: 'I got my first resume and my first job through Upkey.',
    profileName: 'Jasper Tryskuc',
    id: 'profile1',
    specialization: `Accounting student, Saint Xavier university`,
    imageWidth: '218',
    imageHeight: '185',
    type: 'text'
  }
]

export const CAREER_CREATION_SECTION = {
  title: `Career Creation Course `,
  imageSrc: `/assets/images/pages/public/shared/graphic_ccc.webp`,
  fallBackImageSrc: `/assets/images/pages/public/shared/graphic_ccc.png`,
  imageWidth: '696',
  imageHeight: '613',
  fallBackWidth: '696',
  fallBackHeight: '613',
  description: `Join our FREE course with career advice, hacks, and tips from industry-leading professionals. From finding a job you love to excelling at your new position, it’s all covered! `
}

export const COMMUNITY_SECTION = {
  title: `Join the Community!`,
  imageSrc: `/assets/images/pages/public/shared/altGPA.webp`,
  fallBackImageSrc: `/assets/images/pages/public/shared/altGPA.png`,
  imageWidth: '771',
  imageHeight: '671',
  fallBackWidth: '514',
  fallBackHeight: '448',
  description: `Finding a job and starting your career is always easier with a supportive community. Join our Discord to ask for career advice and network with like-minded peers. `
}

export const SELF_BRANDING_SECTION = {
  title: `How to find your voice: Intro
  <br/>to self-branding`,
  imageSrc: `/assets/images/pages/public/home/landing_page/self-branding-course.webp`,
  fallBackImageSrc: `/assets/images/pages/public/home/landing_page/self-branding-course.png`,
  imageWidth: '505',
  imageHeight: '437',
  fallBackWidth: '505',
  fallBackHeight: '437',
  description: `Discover our library of answers, advice, and tips about career budiling and education. Comforting, honest resolutions to your compelling questions.`
}
export const JOB_INTERNSHIP_SECTION = {
  title: `Jobs & Internships`,
  imageSrc: `/assets/images/pages/public/shared/jobs-and-internships.webp`,
  fallBackImageSrc: `/assets/images/pages/public/shared/jobs-and-internships.png`,
  imageWidth: '584',
  imageHeight: '412',
  fallBackWidth: '584',
  fallBackHeight: '412',
  description: `Explore over one million jobs and internships that are updated daily. Easily search, apply and start your career on Upkey’s job board.`
}
export const CAREER_RESOURCE = {
  title: `Career Resources`,
  description: `Accelerate your career with our free on-demand career resources. Learn new skills, get career advice, network with peers, and so much more!    `
}

export const CHROME_EXTENSION_SECTION = {
  title: `Get the Chrome Extension`,
  imageSrc: `/assets/images/pages/public/home/landing_page/chrome-extension.webp`,
  fallBackImageSrc: `/assets/images/pages/public/home/landing_page/chrome-extension.png`,
  imageWidth: '540',
  imageHeight: '534',
  fallBackWidth: '540',
  fallBackHeight: '534',
  description: `Match your resume with any job before you apply, then integrate suggestions to get a higher score and land an interview. `
}

export const PARTNERS_SECTION = [
  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/concordia-chicago.png',
    imageAlt: 'Concordia Chicago Logo',
    id: 'Conordia',
    width: 170,
    height: 80
  },
  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/purdue.png',
    imageAlt: 'Purdue Logo',
    id: 'Purdue',
    width: 170,
    height: 80
  },
  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/baylor-uni.png',
    imageAlt: 'Baylor Logo',
    id: 'Baylor',
    width: 170,
    height: 80
  },
  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/saint-xavier.png',
    imageAlt: 'Saint-Xavier Logo',
    id: 'Saint-Xavier',
    width: 170,
    height: 80
  },
  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/loyola-uni.png',
    imageAlt: 'Loyola Logo',
    id: 'Loyola',
    width: 170,
    height: 80
  },

  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/depaul-university.png',
    imageAlt: 'Depaul Logo',
    id: 'Depaul',
    width: 170,
    height: 80
  },
  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/UIC.png',
    imageAlt: 'UIC Logo',
    id: 'UIC',
    width: 170,
    height: 80
  },
  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/roosevelt-uni.png',
    imageAlt: 'Roosevelt Logo',
    id: 'Roosevelt',
    width: 170,
    height: 80
  },
  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/UCF.png',
    imageAlt: 'UCF Logo',
    id: 'UCF',
    width: 170,
    height: 80
  },
  {
    partnerImageUrl: 'assets/images/pages/public/home/universities_logos/IIT.png',
    imageAlt: 'IIT Logo',
    id: 'IIT',
    width: 170,
    height: 80
  }
]

export const FAQS: IFAQ[] = [
  {
    id: 1,
    title: 'How do I submit my resume for an employment opportunity?',
    description: `<p class="my-1">Please submit your resume for an employment opportunity by.
     <a class="cursor-pointer hover:text-blue-50"
    href="https://cbrands.wd5.myworkdayjobs.com/CBI_External_Careers">applying online</a>.</p> `
  },
  {
    id: 2,
    title: 'How will I know when a new opportunity becomes available?',
    description: `<p class="my-1">New positions are continuously being posted on our web site, please check back frequently.</p>`
  },
  {
    id: 3,
    title: 'Can I apply for multiple openings?',
    description: `<p class="my-1">Yes, you can apply for as many positions as you are interested in, as long as you meet the basic qualifications.<p/>
    `
  },
  {
    id: 4,
    title: 'My password is not working or I forgot it. What should I do?',
    description: `<p class="my-1">

    Please visit our job search site. Click the sign-on button at the top of the page. ‘Forgot Password’ will be located in the bottom right-hand corner of the box. Follow the prompts to reset your password.</p>`
  },
  {
    id: 5,
    title: 'What if I have difficulty attaching my resume to my profile?',
    description: `<p class="my-1">You can either upload your resume from the computer you’re using or your LinkedIn profile. Please ensure to attach your resume to each individual job application that you submit. Resumes are not shared between job applications. If you’d like to make changes after you apply please send a request to  <a href="mailto:careers@cbrands.com" class="cursor-pointer text-blue-50 hover:underline" target="blank">career@cbrands.com</a>, </p>

    `
  },
  {
    id: 6,
    title: 'I recently submitted my information for a position. What’s the next step?',
    description: `<p class="my-1">When you apply for a position, you’ll receive an e-mail confirmation acknowledging our receipt of your application. Our Talent Acquisition Team will review candidates to identify those whose experiences and qualifications most closely match the position specifications. We appreciate your patience as we carefully review each candidate's background against the experience and qualifications sought for the opportunity.</p>`
  },
  {
    id: 7,
    title: 'How do I submit my resume for an employment opportunity?',
    description: `<div><p class="my-1">When you apply for a position, you’ll receive an e-mail confirmation acknowledging our receipt of your application. Our Talent Acquisition Team will review candidates to identify those whose experiences and qualifications most closely match the position specifications. We appreciate your patience as we carefully review each candidate's background against the experience and qualifications sought for the opportunity.
    </p>
<p class="my-2">    If you’re identified as a candidate, you’ll be contacted by a recruiter who will outline next steps. If you’re not identified as a fit for the position you applied for, you still may be contacted about other opportunities that align with your profile and/or interests. Your profile will remain on record and you can update your profile at any time.</p>
    <p/>
    <p class="my-1">Should you wish to delete your account, please contact us at <a href="mailto:careers@cbrands.com" class="cursor-pointer text-blue-50 hover:underline" target="blank">career@cbrands.com</a></p></div>`
  },
  {
    id: 8,
    title:
      'I was referred for a specific position and wasn’t hired. Will you consider my resume for other opportunities?',
    description: `<div><p class="my-1">We’ll consider you a candidate for any positions for which you directly apply. In addition, if there are other positions we feel you might be an appropriate candidate for, we’ll contact you directly to gauge your interest in that position.
</p>
<p class="my-2">
    At Constellation Brands, we are committed to hiring talented individuals, and to providing an exceptional recruiting experience from start to finish. We want to answer questions you have about joining our company. If the Q&A above did not answer your particular inquiry, please contact us by email at <a href="mailto:careers@cbrands.com" class="cursor-pointer text-blue-50 hover:underline" target="blank">career@cbrands.com</a> (please note that resume submissions are not accepted at this address and will not be reviewed).</p></div>`
  }
]

const CHROME_EXTENSION_SITES_BASE_URL = 'assets/images/pages/public/home/extension_sites_logos'
export const CHROME_EXTENSION_SITES = [
  {
    id: 'indeed',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/indeed.png`,
    width: 90,
    height: 27
  },
  {
    id: 'glassdoor',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/glassdoor.png`,
    width: 90,
    height: 18
  },
  {
    id: 'linkedin',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/linkedin.png`,
    width: 90,
    height: 22
  },
  {
    id: 'usajobs',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/usajobs.png`,
    width: 90,
    height: 22
  },
  {
    id: 'careerbuilder',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/careerbuilder.png`,
    width: 90,
    height: 12
  },
  {
    id: 'collegerecruiter',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/collegerecruiter.png`,
    width: 66,
    height: 27
  },
  {
    id: 'zipreccruiter',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/ziprecruiter.png`,
    width: 90,
    height: 20
  },
  {
    id: 'jobget',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/jobget.png`,
    width: 90,
    height: 20
  },
  {
    id: 'monster',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/monster.png`,
    width: 90,
    height: 15
  },
  {
    id: 'simplyhired',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/simplyhired.png`,
    width: 90,
    height: 15
  },
  {
    id: 'snagajob',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/snagajob.png`,
    width: 90,
    height: 21
  },
  {
    id: 'dice',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/dice.png`,
    width: 68,
    height: 36
  },
  {
    id: 'flexjobs',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/flexjobs.png`,
    width: 90,
    height: 41
  },
  {
    id: 'getwork',
    imageSrc: `${CHROME_EXTENSION_SITES_BASE_URL}/getwork.png`,
    width: 90,
    height: 30
  }
]
